(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-bkp"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  if (!customElements.get('product-modal')) customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  // Loyoly product loyalty-points card (DB Pass): styles the app block rendered above via
  // {%- when '@app' -%} inside .product__info-container. Loyoly's title setting (templates/product.json)
  // is reduced to just "+{loyalty_points}" (the number); the localized description comes from the theme
  // locale files (locales/*.json -> 'loyoly.points_earned'), rendered server-side per storefront locale
  // into #db-loy-desc-src and read here. We also make the whole #loy-container box act as the link.
  // CSS lives in assets/custom.css. Section-scoped so it loads with the product section, not at end of <body>.
  (function () {
    // Server-rendered, locale-correct phrase (single source of truth = locale files; editable in Admin).
    function loyDesc() {
      var el = document.getElementById('db-loy-desc-src');
      return el ? el.textContent.trim() : '';
    }

    function setupLoy() {
      var box = document.getElementById('loy-container');
      var t = document.getElementById('loyoly-points');
      if (!box || !t) return;

      // Build [big number] + [localized description], but ONLY when the node holds the real number
      // and isn't already split. We key off "are the .db-loy-num spans present?" rather than a
      // one-time flag, because Loyoly RE-WRITES #loyoly-points on load AND on variant change, which
      // wipes our spans. A one-time flag survives that re-write and would leave the raw "+188" text
      // showing; the spans check self-heals (re-splits) every time. It can't loop: once the spans
      // exist this block is skipped. The number comes from Loyoly; the phrase is always the localized
      // one from the locale files (we ignore any text Loyoly appends). "+{loyalty_points}" won't match.
      if (!t.querySelector('.db-loy-num')) {
        var m = t.textContent.trim().match(/^(\+?\d+)/);
        if (m) {
          t.innerHTML = '<span class="db-loy-num">' + m[1] + '</span><span class="db-loy-desc"></span>';
        }
      }

      // Ensure the description holds our localized text. Done unconditionally (not just after our own
      // split) so it also REPAIRS an empty/wrong description left by another script — e.g. a stale
      // duplicate that split "+188" into number + EMPTY description. Idempotent: stops once it matches,
      // and the stale script's own one-time guard means it won't fight back.
      var descEl = t.querySelector('.db-loy-desc');
      var want = loyDesc();
      if (descEl && want && descEl.textContent !== want) descEl.textContent = want;

      // Reveal once the real number is present (works whether we or another script did the split).
      if (t.querySelector('.db-loy-num')) box.classList.add('db-loy-ready');

      // make the whole box act as the link
      if (!box.dataset.clickBound) {
        box.dataset.clickBound = '1';
        box.setAttribute('role', 'link');
        box.setAttribute('tabindex', '0');
        box.style.cursor = 'pointer';
        box.addEventListener('click', function () {
          var a = box.querySelector('.loy-product-point-link a');
          if (!a) return;
          var href = a.getAttribute('href');
          if (!href) return;
          if (a.getAttribute('target') === '_blank') window.open(href, '_blank');
          else window.location.href = href;
        });
        box.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); box.click(); }
        });
      }
    }
    setupLoy();
    new MutationObserver(setupLoy).observe(document.documentElement, { childList: true, subtree: true });
  })();

  const PRODUCT_MODAL_MOBILE_BREAKPOINT = 750;

  class ProductModal extends ModalDialog {
    constructor() {
      super();
      this._zoomTarget = null;
      this._swipePair = null;
      this._modalZoomed = false;
      this._modalZoomScale = 1;
      this._modalZoomX = 0;
      this._modalZoomY = 0;
      this._touchStartX = 0;
      this._touchStartY = 0;
      this._swipeHandled = false;
      this._lastTapTime = 0;
      this._lastTapX = 0;
      this._lastTapY = 0;
      this._lastTapEndTime = 0;
      this._pinchStartDist = 0;
      this._pinchStartScale = 1;
      this._tapMoved = false;
      this._didPanThisGesture = false;
      this._swipeDx = 0;
      this._isDraggingSwipe = false;
      this._swipeAnimating = false;
      this._boundTouchStart = this._handleContentTouchStart.bind(this);
      this._boundTouchMove = this._handleContentTouchMove.bind(this);
      this._boundTouchEnd = this._handleContentTouchEnd.bind(this);
      const footer = this.querySelector('.product-media-modal__footer');
      if (footer) {
        this._countEl = footer.querySelector('.product-media-modal__current');
        const prevBtn = footer.querySelector('.product-media-modal__prev');
        const nextBtn = footer.querySelector('.product-media-modal__next');
        const closeBtn = footer.querySelector('.product-media-modal__footer-close');
        if (prevBtn) prevBtn.addEventListener('click', () => this.goPrev());
        if (nextBtn) nextBtn.addEventListener('click', () => this.goNext());
        if (closeBtn) closeBtn.addEventListener('click', () => this.hide());
      }
    }

    getMediaItems() {
      const content = this.querySelector('.product-media-modal__content');
      return content ? Array.from(content.querySelectorAll(':scope > [data-media-id]')) : [];
    }

    updateCount() {
      if (!this._countEl) return;
      const items = this.getMediaItems();
      const activeIndex = items.findIndex((el) => el.classList.contains('active'));
      this._countEl.textContent = activeIndex >= 0 ? activeIndex + 1 : 1;
      const footer = this.querySelector('.product-media-modal__footer');
      if (footer) {
        const prevBtn = footer.querySelector('.product-media-modal__prev');
        const nextBtn = footer.querySelector('.product-media-modal__next');
        if (prevBtn) prevBtn.disabled = activeIndex <= 0;
        if (nextBtn) nextBtn.disabled = activeIndex >= items.length - 1 || activeIndex < 0;
      }
    }

    switchToMedia(targetEl) {
      this.destroyModalZoom();
      this._resetAllSlideTransforms();
      this.getMediaItems().forEach((el) => el.classList.remove('active'));
      targetEl.classList.add('active');
      targetEl.scrollIntoView();
      const container = this.querySelector('[role="document"]');
      if (container) {
        if (window.innerWidth >= 750 && targetEl.width) container.scrollLeft = (targetEl.width - container.clientWidth) / 2;
        else container.scrollLeft = 0;
      }
      const deferredMedia = targetEl.querySelector('deferred-media');
      if (deferredMedia && deferredMedia.querySelector('template') && deferredMedia.querySelector('template').content.querySelector('.js-youtube'))
        deferredMedia.loadContent();
      this.updateCount();
      this.initModalZoom();
    }

    goPrev() {
      const items = this.getMediaItems();
      const activeIndex = items.findIndex((el) => el.classList.contains('active'));
      if (activeIndex > 0) this.switchToMedia(items[activeIndex - 1]);
    }

    goNext() {
      const items = this.getMediaItems();
      const activeIndex = items.findIndex((el) => el.classList.contains('active'));
      if (activeIndex >= 0 && activeIndex < items.length - 1) this.switchToMedia(items[activeIndex + 1]);
    }

    /** Returns true if viewport is mobile (modal gallery optimisations apply). */
    _isMobile() {
      return window.innerWidth < PRODUCT_MODAL_MOBILE_BREAKPOINT;
    }

    /** Setup swipe navigation on modal content (mobile only). */
    _setupMobileSwipe() {
      if (!this._isMobile()) return;
      const content = this.querySelector('.product-media-modal__content');
      if (!content) return;
      content.addEventListener('touchstart', this._boundTouchStart, { passive: true });
      content.addEventListener('touchmove', this._boundTouchMove, { passive: false });
      content.addEventListener('touchend', this._boundTouchEnd, { passive: true });
    }

    /** Remove swipe navigation listeners. */
    _teardownMobileSwipe() {
      const content = this.querySelector('.product-media-modal__content');
      if (!content) return;
      content.removeEventListener('touchstart', this._boundTouchStart);
      content.removeEventListener('touchmove', this._boundTouchMove);
      content.removeEventListener('touchend', this._boundTouchEnd);
    }

    /** Handle content touchstart for swipe detection. */
    _handleContentTouchStart(e) {
      if (e.touches.length !== 1) return;
      this._touchStartX = e.touches[0].clientX;
      this._touchStartY = e.touches[0].clientY;
      this._swipeHandled = false;
      this._tapMoved = false;
      this._isDraggingSwipe = false;
    }

    /** Handle content touchmove: drag slide or prevent default when horizontal swipe. */
    _handleContentTouchMove(e) {
      if (e.touches.length !== 1 || this._modalZoomed || this._swipeAnimating) return;
      const dx = e.touches[0].clientX - this._touchStartX;
      const dy = e.touches[0].clientY - this._touchStartY;
      if (Math.abs(dx) > 8 || Math.abs(dy) > 8) this._tapMoved = true;
      const isHorizontal = Math.abs(dx) > 20 && Math.abs(dx) > Math.abs(dy);
      if (isHorizontal) {
        this._swipeHandled = true;
        this._isDraggingSwipe = true;
        e.preventDefault();
        this._applySwipeDragTransform(dx);
      }
    }

    /** Handle content touchend: snap back or animate swipe then switch media. */
    _handleContentTouchEnd(e) {
      if (e.touches.length !== 0) return;
      if (this._isDraggingSwipe) {
        this._isDraggingSwipe = false;
        const dx = e.changedTouches[0].clientX - this._touchStartX;
        const dy = e.changedTouches[0].clientY - this._touchStartY;
        const threshold = 50;
        if (Math.abs(dx) < Math.abs(dy) || Math.abs(dx) < threshold) {
          this._animateSwipeSnapBack();
        } else {
          this._animateSwipeOutThenSwitch(dx > 0 ? 1 : -1);
        }
        return;
      }
      if (!this._swipeHandled) return;
      const dx = e.changedTouches[0].clientX - this._touchStartX;
      const dy = e.changedTouches[0].clientY - this._touchStartY;
      const threshold = 50;
      if (Math.abs(dx) < Math.abs(dy) || Math.abs(dx) < threshold) return;
      if (dx > 0) this.goPrev();
      else this.goNext();
    }

    /** Returns the active media slide element for swipe drag. */
    _getActiveSlide() {
      if (this._swipePair && this._swipePair.activeSlide) return this._swipePair.activeSlide;
      const content = this.querySelector('.product-media-modal__content');
      return content ? content.querySelector(':scope > [data-media-id].active') : null;
    }

    /** Returns the adjacent slide to reveal for the given swipe direction. */
    _getAdjacentSlide(direction) {
      const items = this.getMediaItems();
      const activeSlide = this._swipePair && this._swipePair.activeSlide ? this._swipePair.activeSlide : this._getActiveSlide();
      const activeIndex = items.indexOf(activeSlide);
      const adjacentIndex = activeIndex - direction;
      if (activeIndex < 0 || adjacentIndex < 0 || adjacentIndex >= items.length) return null;
      return items[adjacentIndex];
    }

    /** Returns the pixel width used to position swipe slides side-by-side. */
    _getSwipeWidth() {
      const content = this.querySelector('.product-media-modal__content');
      if (!content) return 0;
      return content.clientWidth || content.offsetWidth;
    }

    /** Applies drag transforms to the active and adjacent swipe slides. */
    _setSwipePairTransforms(direction, dx, swipePair) {
      if (!swipePair) return;
      const swipeWidth = this._getSwipeWidth();
      swipePair.activeSlide.style.transform = `translate3d(${dx}px, 0, 0)`;
      swipePair.adjacentSlide.style.transform = `translate3d(${dx - (swipeWidth * direction)}px, 0, 0)`;
    }

    /** Sets up the active/adjacent slide pair used during a mobile swipe. */
    _prepareSwipePair(direction) {
      const content = this.querySelector('.product-media-modal__content');
      const activeSlide = this._getActiveSlide();
      const adjacentSlide = this._getAdjacentSlide(direction);
      if (!content || !activeSlide || !adjacentSlide) {
        this._resetAllSlideTransforms();
        return null;
      }
      if (
        this._swipePair &&
        this._swipePair.direction === direction &&
        this._swipePair.activeSlide === activeSlide &&
        this._swipePair.adjacentSlide === adjacentSlide
      ) {
        return this._swipePair;
      }
      this._resetAllSlideTransforms();
      content.style.minHeight = `${content.clientHeight}px`;
      content.classList.add('product-media-modal__content--swiping');
      const contentPaddingBottom = window.getComputedStyle(content).paddingBottom;
      const paddingBottomPx = parseFloat(contentPaddingBottom) || 0;
      const overlayHeight = content.clientHeight - paddingBottomPx;
      activeSlide.classList.add('active');
      activeSlide.classList.add('product-media-modal__swipe-active');
      adjacentSlide.classList.add('active');
      adjacentSlide.classList.add('product-media-modal__swipe-adjacent');
      [activeSlide, adjacentSlide].forEach((slideEl) => {
        slideEl.style.display = 'flex';
        slideEl.style.position = 'absolute';
        slideEl.style.top = '0';
        slideEl.style.left = '0';
        slideEl.style.right = '0';
        slideEl.style.bottom = 'auto';
        slideEl.style.height = `${overlayHeight}px`;
        slideEl.style.width = '100%';
        slideEl.style.maxWidth = '100%';
        slideEl.style.margin = '0';
        slideEl.style.alignItems = 'center';
        slideEl.style.justifyContent = 'center';
      });
      this._swipePair = { direction, activeSlide, adjacentSlide };
      this._setSwipePairTransforms(direction, 0, this._swipePair);
      return this._swipePair;
    }

    /** Applies horizontal drag translation to the active slide during swipe. */
    _applySwipeDragTransform(dx) {
      const slide = this._getActiveSlide();
      if (!slide) return;
      this._swipeDx = dx;
      const direction = dx > 0 ? 1 : -1;
      const swipePair = this._prepareSwipePair(direction);
      if (swipePair) {
        this._setSwipePairTransforms(direction, dx, swipePair);
        return;
      }
      slide.style.transform = `translateX(${dx}px)`;
    }

    /** Animates swipe back to center when threshold not reached. */
    _animateSwipeSnapBack() {
      const slide = this._getActiveSlide();
      if (!slide || this._swipeAnimating) return;
      this._swipeAnimating = true;
      const swipePair = this._swipePair;
      if (swipePair) {
        const { direction, activeSlide, adjacentSlide } = swipePair;
        activeSlide.style.transition = 'transform 0.25s ease-out';
        adjacentSlide.style.transition = 'transform 0.25s ease-out';
        this._setSwipePairTransforms(direction, 0, swipePair);
      } else {
        slide.style.transition = 'transform 0.25s ease-out';
        slide.style.transform = 'translateX(0)';
      }
      this._swipeDx = 0;
      const onEnd = () => {
        slide.removeEventListener('transitionend', onEnd);
        this._resetAllSlideTransforms();
        this._swipeAnimating = false;
      };
      slide.addEventListener('transitionend', onEnd);
    }

    /** Animates current slide out then calls goPrev or goNext and resets. */
    _animateSwipeOutThenSwitch(direction) {
      const slide = this._getActiveSlide();
      if (!slide || this._swipeAnimating) return;
      const targetSlide = this._getAdjacentSlide(direction);
      if (!targetSlide) {
        this._animateSwipeSnapBack();
        return;
      }
      this._swipeAnimating = true;
      const swipePair = this._prepareSwipePair(direction);
      slide.style.transition = 'transform 0.25s ease-out';
      if (swipePair) {
        swipePair.adjacentSlide.style.transition = 'transform 0.25s ease-out';
        this._setSwipePairTransforms(direction, this._getSwipeWidth() * direction, swipePair);
      }
      slide.style.transform = `translateX(${100 * direction}%)`;
      const onEnd = () => {
        slide.removeEventListener('transitionend', onEnd);
        this._resetAllSlideTransforms();
        this._swipeAnimating = false;
        this.switchToMedia(targetSlide);
      };
      slide.addEventListener('transitionend', onEnd);
    }

    /** Clamps _modalZoomX/Y so the scaled image never reveals blank area (uses rendered image vs viewport). */
    _clampModalPanFromGeometry() {
      if (!this._zoomTarget || this._modalZoomScale <= 1) return;
      const wrapper = this._zoomTarget;
      const img = wrapper.querySelector('img');
      const viewportW = wrapper.offsetWidth;
      const viewportH = wrapper.offsetHeight;
      const contentW = img ? img.offsetWidth : viewportW;
      const contentH = img ? img.offsetHeight : viewportH;
      const scaledW = contentW * this._modalZoomScale;
      const scaledH = contentH * this._modalZoomScale;
      const maxX = Math.max(0, (scaledW - viewportW) / 2);
      const maxY = Math.max(0, (scaledH - viewportH) / 2);
      this._modalZoomX = Math.min(maxX, Math.max(-maxX, this._modalZoomX));
      this._modalZoomY = Math.min(maxY, Math.max(-maxY, this._modalZoomY));
    }

    /** Apply current zoom/pan transform to the active zoom wrapper. */
    _applyModalZoomTransform() {
      if (!this._zoomTarget) return;
      this._clampModalPanFromGeometry();
      const s = this._modalZoomScale;
      const x = this._modalZoomX;
      const y = this._modalZoomY;
      this._zoomTarget.style.transform = `translate(${x}px, ${y}px) scale(${s})`;
      this._zoomTarget.style.transformOrigin = 'center center';
    }

    /** Reset zoom state and transform on the given wrapper. */
    _resetZoomWrapper(el) {
      if (!el) return;
      el.style.transform = '';
      el.style.transformOrigin = '';
    }

    /** Clears swipe/zoom transient transforms and transition on all media slides. */
    _resetAllSlideTransforms() {
      const content = this.querySelector('.product-media-modal__content');
      if (content) {
        content.classList.remove('product-media-modal__content--swiping');
        content.style.minHeight = '';
      }
      this.getMediaItems().forEach((el) => {
        el.style.display = '';
        el.style.position = '';
        el.style.inset = '';
        el.style.bottom = '';
        el.style.top = '';
        el.style.left = '';
        el.style.right = '';
        el.style.height = '';
        el.style.width = '';
        el.style.maxWidth = '';
        el.style.margin = '';
        el.style.alignItems = '';
        el.style.justifyContent = '';
        el.style.transition = '';
        el.style.transform = '';
        if (this._swipePair && el === this._swipePair.adjacentSlide) el.classList.remove('active');
        el.classList.remove('product-media-modal__swipe-active', 'product-media-modal__swipe-adjacent');
      });
      this._swipePair = null;
    }

    /** Handle touch on zoom wrapper: pinch, double-tap, pan (mobile only). */
    _initMobileZoomTouch(wrapper) {
      if (!wrapper || !this._isMobile()) return;
      const distance = (a, b) => Math.hypot(a.clientX - b.clientX, a.clientY - b.clientY);
      const TAP_MOVE_THRESHOLD_PX = 15;
      const DOUBLE_TAP_WINDOW_MS = 400;
      const DOUBLE_TAP_DISTANCE_PX = 40;
      const TAP_DEBOUNCE_MS = 80;

      wrapper.addEventListener('touchstart', (e) => {
        if (e.touches.length === 1) {
          this._touchStartX = e.touches[0].clientX;
          this._touchStartY = e.touches[0].clientY;
          this._tapMoved = false;
          this._didPanThisGesture = false;
        }
        if (e.touches.length === 2) {
          this._pinchStartDist = distance(e.touches[0], e.touches[1]);
          this._pinchStartScale = this._modalZoomScale;
        }
      }, { passive: false });
      wrapper.addEventListener('touchend', (e) => {
        if (e.changedTouches.length !== 1) return;
        if (this._didPanThisGesture) return;
        const t = e.changedTouches[0];
        const movePx = distance({ clientX: this._touchStartX, clientY: this._touchStartY }, { clientX: t.clientX, clientY: t.clientY });
        if (movePx >= TAP_MOVE_THRESHOLD_PX) return;
        const now = Date.now();
        if (now - this._lastTapEndTime < TAP_DEBOUNCE_MS) return;
        const withinWindow = now - this._lastTapTime < DOUBLE_TAP_WINDOW_MS;
        const withinDistance = Math.abs(t.clientX - this._lastTapX) < DOUBLE_TAP_DISTANCE_PX && Math.abs(t.clientY - this._lastTapY) < DOUBLE_TAP_DISTANCE_PX;
        if (withinWindow && withinDistance) {
          this._lastTapTime = 0;
          this._lastTapEndTime = now;
          e.preventDefault();
          if (this._modalZoomed) {
            this._modalZoomed = false;
            this._modalZoomScale = 1;
            this._modalZoomX = 0;
            this._modalZoomY = 0;
          } else {
            this._modalZoomed = true;
            this._modalZoomScale = 2.5;
            this._modalZoomX = 0;
            this._modalZoomY = 0;
          }
          this._applyModalZoomTransform();
        } else {
          this._lastTapTime = now;
          this._lastTapX = t.clientX;
          this._lastTapY = t.clientY;
          this._lastTapEndTime = now;
        }
      }, { passive: false });
      wrapper.addEventListener('touchmove', (e) => {
        if (e.touches.length === 2) {
          e.preventDefault();
          const d = distance(e.touches[0], e.touches[1]);
          this._modalZoomScale = Math.min(4, Math.max(1, this._pinchStartScale * (d / this._pinchStartDist)));
          this._modalZoomed = this._modalZoomScale > 1;
          this._applyModalZoomTransform();
        } else if (e.touches.length === 1 && this._modalZoomed) {
          e.preventDefault();
          this._didPanThisGesture = true;
          this._modalZoomX += e.touches[0].clientX - this._touchStartX;
          this._modalZoomY += e.touches[0].clientY - this._touchStartY;
          this._touchStartX = e.touches[0].clientX;
          this._touchStartY = e.touches[0].clientY;
          this._tapMoved = true;
          this._applyModalZoomTransform();
        }
      }, { passive: false });
    }

    destroyModalZoom() {
      this._modalZoomed = false;
      this._modalZoomScale = 1;
      this._modalZoomX = 0;
      this._modalZoomY = 0;
      this._swipeDx = 0;
      this._isDraggingSwipe = false;
      this._lastTapTime = 0;
      this._lastTapEndTime = 0;
      if (this._zoomTarget) {
        this._resetZoomWrapper(this._zoomTarget);
        if (window.jQuery) window.jQuery(this._zoomTarget).trigger('zoom.destroy');
        this._zoomTarget = null;
      }
    }

    initModalZoom() {
      const activeEl = this.querySelector('.product-media-modal__content > [data-media-id].active');
      if (!activeEl || !activeEl.classList.contains('product-media-modal__zoom-wrapper')) return;
      const img = activeEl.querySelector('img');
      if (!img) return;
      this._zoomTarget = activeEl;
      if (this._isMobile()) {
        this._initMobileZoomTouch(activeEl);
        return;
      }
      if (!window.jQuery) return;
      window.jQuery(activeEl).zoom({
        on: 'click',
        onZoomIn: function() { window.jQuery(activeEl).css('cursor', 'zoom-out'); },
        onZoomOut: function() { window.jQuery(activeEl).css('cursor', 'zoom-in'); }
      });
    }

    /** Locks body scroll so background does not scroll when modal is open (avoids browser UI show/hide). */
    _lockBodyScroll() {
      this._bodyScrollY = window.scrollY ?? window.pageYOffset;
      document.body.classList.add('product-media-modal-open');
      document.body.style.top = `-${this._bodyScrollY}px`;
      document.body.style.position = 'fixed';
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';
      document.body.style.overflow = 'hidden';
    }

    /** Restores body scroll and position after modal close. */
    _unlockBodyScroll() {
      document.body.classList.remove('product-media-modal-open');
      document.body.style.top = '';
      document.body.style.position = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.width = '';
      document.body.style.overflow = '';
      if (this._bodyScrollY != null) {
        window.scrollTo(0, this._bodyScrollY);
        this._bodyScrollY = null;
      }
    }

    hide() {
      this._teardownMobileSwipe();
      this.destroyModalZoom();
      this._resetAllSlideTransforms();
      this._clearVisualViewportHeight();
      this._unlockBodyScroll();
      if (typeof this._viewportLogCleanup === 'function') this._viewportLogCleanup();
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this._lockBodyScroll();
      this.showActiveMedia();
      this.updateCount();
      this.initModalZoom();
      this._setupMobileSwipe();
      this._applyVisualViewportHeight();
      const self = this;
      requestAnimationFrame(function() {
        requestAnimationFrame(function() { self._applyVisualViewportHeight(); });
      });
      if (window.visualViewport && !this._viewportLogBound) {
        this._viewportLogBound = true;
        const onViewportChange = function() {
          if (self.hasAttribute('open')) self._applyVisualViewportHeight();
        };
        window.visualViewport.addEventListener('resize', onViewportChange);
        window.visualViewport.addEventListener('scroll', onViewportChange);
        this._viewportLogCleanup = function() {
          window.visualViewport.removeEventListener('resize', onViewportChange);
          window.visualViewport.removeEventListener('scroll', onViewportChange);
        };
      }
    }

    /** Sets modal and dialog height to visual viewport height on mobile so footer stays above browser UI. */
    _applyVisualViewportHeight() {
      if (!this._isMobile() || !this.hasAttribute('open')) return;
      const vv = window.visualViewport;
      if (!vv) return;
      const h = Math.round(vv.height) + 'px';
      this.style.height = h;
      const dialog = this.querySelector('.product-media-modal__dialog');
      if (dialog) dialog.style.height = h;
    }

    /** Clears inline heights applied for visual viewport so CSS takes over again. */
    _clearVisualViewportHeight() {
      this.style.height = '';
      const dialog = this.querySelector('.product-media-modal__dialog');
      if (dialog) dialog.style.height = '';
    }

    showActiveMedia() {
      const mediaId = this.openedBy.getAttribute('data-media-id');
      if (!mediaId) return;
      this.querySelectorAll('.product-media-modal__content > [data-media-id]').forEach((element) => {
        element.classList.remove('active');
      });
      const activeMedia = this.querySelector(`.product-media-modal__content > [data-media-id="${mediaId}"]`);
      if (!activeMedia) return;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      if (container) {
        if (window.innerWidth >= 750 && activeMedia.width)
          container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;
        else
          container.scrollLeft = 0;
      }

      const deferredMedia = activeMedia.querySelector('deferred-media');
      if (deferredMedia) {
        const template = deferredMedia.querySelector('template');
        if (template && template.content && template.content.querySelector('.js-youtube'))
          deferredMedia.loadContent();
      }
    }
  }

  if (!customElements.get('product-modal')) customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
